// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { addSeconds as fn } from "../addSeconds.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const addSecondsWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default addSecondsWithOptions;
